import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=599d1c7c"
import script from "./PersonInfo.vue?vue&type=script&lang=js"
export * from "./PersonInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=599d1c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports